import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { BidService } from '@6grain/masofa-monolith-api-client/crop-monitoring/api/bid.service';
import { BidTemplatesService } from '@6grain/masofa-monolith-api-client/crop-monitoring/api/bidTemplates.service';
import { RegionService } from '@6grain/masofa-monolith-api-client/dictionaries/api/region.service';
import { CropService } from '@6grain/masofa-monolith-api-client/dictionaries/api/crop.service';
import { BidTypeService } from '@6grain/masofa-monolith-api-client/dictionaries/api/bidType.service';
import { MetadataCacheService } from './metadata-cache.service';
import {
  BidBaseGetQuery,
  ApiBid,
  FieldFilter,
  FilterOperator,
  SortType,

} from './api-types';
import {Bid} from "@6grain/masofa-monolith-api-client/crop-monitoring";
import {environment} from '@root/src/environments/environment';

export interface Bids {
  id?: string;
  active?: boolean;
  bidStateId?: string;
  bidTypeId?: string;
  cancelled?: boolean;
  comment?: string;
  contentId?: string;
  contourId?: string;
  createDate?: string;
  createUser?: string;
  cropId?: string;
  deadlineDate?: string;
  description?: string;
  endDate?: string;
  fieldId?: string;
  foremanId?: string;
  number?: string;
  regionId?: string;
  startDate?: string;
  updateDate?: string;
  updateUser?: string;
  userId?: string;
  workerId?: string;
}

export interface BidResponse {
  data: Bid[];
  numberOfPages: number;
  pageSize: number;
  startPage: number;
  totalCount?: number;
}

export interface BidFilter {
  active?: boolean;
  bidStateId?: string;
  bidTypeId?: string;
  cancelled?: boolean;
  comment?: string;
  contentId?: string;
  contourId?: string;
  createDate?: string;
  createUser?: string;
  cropId?: string;
  deadlineDate?: string[];
  QwenAnomalyCount?: number;
  endDate?: string;
  fieldId?: string;
  foremanId?: string;
  id?: string;
  number?: string;
  regionId?: string;
  startDate?: string;
  updateDate?: string;
  updateUser?: string;
  userId?: string;
  workerId?: string;
  anomaliesCount?: number;
}

@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  constructor(
    private http: HttpClient,
    private bidService: BidService,
    private bidTemplatesService: BidTemplatesService,
    private regionService: RegionService,
    private cropService: CropService,
    private bidTypeService: BidTypeService,
    private metadataCache: MetadataCacheService
  ) {}

  getRequests(params: { start?: number; size?: number; filters?: BidFilter }): Observable<BidResponse> {
    const { start, size, filters } = params;

    const fieldFilters: FieldFilter[] = [];
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          fieldFilters.push({
            filterField: key,
            filterOperator: FilterOperator.NUMBER_0, // Equals operator
            filterValue: value
          });
        }
      });
    }

    if (!params.size) {
        params.size = 20; // Default page size
    }

    if (!params.start) {
        params.start = 1; // Default start page
    }

    // Create query for API
    const query: BidBaseGetQuery = {
      offset: (start ||1 - 1) * (size||20),
      filters: fieldFilters,
      sortBy: 'lastUpdateAt',
      sort: SortType.NUMBER_1 // Descending
    };


    // Use the monolith API client
    return this.bidService.cropMonitoringBidCustomGetByQueryPost(query).pipe(
      map((response: any) => {

        return {
          data: response,
          pageSize: 20,
          startPage: 0,
        } as BidResponse;
      })
    );
  }

  getRequestById(id: string): Observable<Bid> {
    return this.bidService.cropMonitoringBidGetByIdIdGet(id).pipe(
      map((apiBid: ApiBid) => apiBid as Bid)
    );
  }

  createRequest(bid: Bid): Observable<Bid> {
    return this.bidService.cropMonitoringBidCreatePost(bid as any).pipe(
      map((result: string) => ({ ...bid, id: result } as Bid))
    );
  }

  updateRequest(bid: Bid): Observable<Bid> {
    return this.bidService.cropMonitoringBidUpdatePut(bid as any).pipe(
      map((apiBid: ApiBid) => apiBid as Bid)
    );
  }

  cancelRequest(id: string): Observable<Bid> {
    return this.bidService.cropMonitoringBidDeleteIdDelete(id).pipe(
      map((success: boolean) => ({ id, cancelled: success } as Bid))
    );
  }

  getRegions(): Observable<any> {
    // Use cached metadata
    return this.metadataCache.getRegions();
  }

  getCrops(): Observable<any> {
    // Use cached metadata
    return this.metadataCache.getCrops();
  }

  getBidTypes(): Observable<any> {
    // Use cached metadata
    return this.metadataCache.getBidTypes();
  }


  getUsers(typeId?: string): Observable<any[]> {
    return this.http.post<any[]>(`${environment.api}/users/filter`, {
      typeId,
      active: true
    });
  }

  getBidTemplates(params?: { take?: number; offset?: number; filters?: FieldFilter[] }): Observable<any[]> {
    const query = {

    };

    return this.bidTemplatesService.cropMonitoringBidTemplatesGetByQueryPost(query);
  }
}
